export interface OnlineManager {
  isOnline: () => boolean;
  subscribe: (listener?: () => unknown) => () => void;
}
